import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractBasketComponent } from '@df/basket/abstract-basket.component';
import { DfEventService } from '@df/core/service/df-event';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { LastCategoryPathPipe } from '@df/ui/common/last-category-path.pipe';
import { OrderByPipe } from '@df/ui/common/order-by.pipe';
import { DfUiModule } from '@df/ui/df-ui.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { copyToClipboard } from '@df/util/fn/copy-to-clipboard';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { NCmsTrustpilotWidget } from '../../cms/trustpilot-widget/cms-trustpilot-widget.component';
import { BottomPanelComponent } from '../../common/bottom-panel/bottom-panel.component';
import { ButtonStyleComponent } from '../../common/buttons/button-style/button-style.component';
import { InlineButtonComponent } from '../../common/buttons/inline-button/inline-button.component';
import { NBasketViewCms } from './basket-view-cms.component';
import { BasketViewCouponFormComponent } from './coupon-form/basket-view-coupon-form.component';
import { BasketViewItemComponent } from './item/basket-view-item.component';
import { BasketViewPaywithComponent } from './paywith/basket-view-paywith.component';
import { BasketViewSubmitComponent } from './submit/basket-view-submit.component';
import { BasketViewTotalsComponent } from './totals/basket-view-totals.component';

declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.Basket {
        export interface BasketData {
            checkout_disallow?: boolean;
            checkout_disallow_message?: string;
            isVirtual?: boolean;
        }
    }
}

@Component({
    selector: 'basket-view',
    templateUrl: './basket-view.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        BasketViewItemComponent,
        BasketViewCouponFormComponent,
        BasketViewTotalsComponent,
        BasketViewSubmitComponent,
        BasketViewPaywithComponent,
        ICmsClientModule,
        BottomPanelComponent,
        CommonModule,
        DfUiModule,
        TranslationModule,
        ButtonStyleComponent,
        InlineButtonComponent,
        OrderByPipe,
        LastCategoryPathPipe,
        RouterLink,
        DfModuleImageModule
    ]
})
export class BasketViewComponent extends AbstractBasketComponent {
    protected isBasketLinkCopied = false;

    private basketLinkCopiedTimeout?: number;

    @Input()
    content?: NBasketViewCms.IBlockDataContent;

    private event = inject(DfEventService);

    // protected basketCopyButton = 'Copy basket link';

    override ngOnInit() {
        this.event.dispatch({
            id: 'dfBasketView',
            data: {
                context: 'basket'
            }
        });
        super.ngOnInit();
    }

    getTrustpilotComponentData() {
        return {
            id: NCmsTrustpilotWidget.ID,
            hideTrustpilot: this.content?.hideTrustpilot,
            templateId: this.content?.templateId,
            businessunitId: this.content?.businessunitId,
            styleHeight: this.content?.styleHeight,
            styleWidth: this.content?.styleWidth,
            theme: this.content?.theme
        };
    }

    protected get quoteId(): number | undefined {
        if (this.basket.data?.qty) {
            return this.basket.data.quote_id;
        }
        return undefined;
    }

    protected copyBasketLink() {
        const quoteId = this.quoteId;
        if (quoteId) {
            clearTimeout(this.basketLinkCopiedTimeout);
            try {
                const url = this.app.url.toUrl(`/api/p/checkout/cart/quote_id/${quoteId}`);
                copyToClipboard(url);
                this.isBasketLinkCopied = true;
                this.detectChanges();
                this.basketLinkCopiedTimeout = this.timeoutService.setTimeout(() => {
                    this.isBasketLinkCopied = false;
                    this.detectChanges();
                }, 5000);
            } catch (e) {}
        }
    }
}
